export default "__VITE_ASSET__DUif$Hif__"